module.exports = __webpack_public_path__ + "static/media/ic_hs_special.059fa861.svg";